<div class="container black-link waitlist mb-4">
  <div class="row">
    <div class="col-md-12 col-lg-12 col-sm-12 text-center">
      <img
        src="/assets/images/octopus-logo-white.png"
        alt="Welcome"
        class="welcome-img"
        />
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 col-lg-12 col-sm-12 text-center">
      <h4>You're on the waitlist!</h4>
      <p>Thank you for your interest in joining Play Octopus.</p>
      <p class="my-4">
        We are currently only accepting drivers who complete a minimum
        of 100 rides per month (25/week). If there is an opportunity for
        lower-activity drivers to join in the future, we will contact
        you directly to let you know.
      </p>
      <p class="mb-3">
        Let us know if you begin driving more in the future, or if
        you’re receiving this message in error:
        <span class="bold-text">contact&#64;playoctopus.com</span>
      </p>
    </div>
  </div>
  <hr />
  @if (referredBy === 'RYDARAPP') {
    <img
      src="https://promotions.api.rydar.io/ping-pong/playoctopus/jan_2019_app.png"
      />
  }
  @if (referredBy === 'RYDAREMAIL') {
    <img
      src="https://promotions.api.rydar.io/ping-pong/playoctopus/jan_2019_email.png"
      />
  }
  <br />
</div>
